import { cn } from '#app/utils/misc.tsx'

type Props = {
	number?: string
	title: React.ReactNode
	subtitle?: React.ReactNode
	className?: string
}

/**
 * Section header: optional small numeric prefix (01/02/…) followed by a
 * left-aligned title. Used to anchor sections within a long page.
 */
export function SectionHeader({ number, title, subtitle, className }: Props) {
	return (
		<header className={cn('', className)}>
			<div className="flex items-baseline gap-4">
				{number ? (
					<span className="text-primary/40 font-mono text-sm font-semibold tracking-widest">
						{number}
					</span>
				) : null}
				<h2 className="text-foreground text-2xl font-bold tracking-tight md:text-3xl">
					{title}
				</h2>
			</div>
			{subtitle ? (
				<p className="text-muted-foreground mt-3 max-w-2xl text-base leading-relaxed">
					{subtitle}
				</p>
			) : null}
		</header>
	)
}
